import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { createUseStyles } from '../../../../../../../../../theming';

const useStyles = createUseStyles({
  code: {
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    lineHeight: 1,
    overflowWrap: 'break-word',
    padding: 2,
  },
});

interface Props {
  open: boolean;
  onClose: () => void;
}

const TimeTrackingDialog: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog onClose={onClose} scroll='paper' open={open}>
      <DialogTitle>Comment ça marche ?</DialogTitle>

      <DialogContent>
        Pour saisir le temps passé sur une intervention, tapez <span className={classes.code}>/time</span>, suivi de la
        durée en minute.
        <br />
        Par exemple, si vous devez enregistrer 1 heure et 5 minutes, tapez{' '}
        <span className={classes.code}>/time 1h 5m</span> ou <span className={classes.code}>/time 65m</span>.
        <br />
        <br />
        <strong>
          Veillez à saisir la commande sur une ligne distincte pour permettre à Scaleed de détecter et d'exécuter
          correctement la commande.
        </strong>
      </DialogContent>

      <DialogActions>
        <Button type='submit' color='primary' onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeTrackingDialog;
